import React, { useEffect, useRef, useState } from 'react';
import ShareSocial from '../ShareSocial';

interface TabContent {
    id: string;
    icon: string;
    iconClass: string;
    heading: string;
    content: string;
}

interface ContributionSectionData {
    tagline: string;
    heading: string;
    description: string;
    source: string;
    tabs: TabContent[];
}

interface ContributionSectionProps {
    data: ContributionSectionData
}

const ContributionSection: React.FC<ContributionSectionProps> = ({
    data
}) => {
    const [activeTab, setActiveTab] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const startTabSwitching = () => {
        intervalRef.current = setInterval(() => {
            setActiveTab((prevTab) => (prevTab + 1) % data.tabs.length);
        }, 10000); // 5 saniye
    };

    const stopTabSwitching = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
    };

    useEffect(() => {
        startTabSwitching(); // Başlangıçta interval başlat

        return () => {
            stopTabSwitching(); // Component unmount olduğunda interval durdur
        };
    }, [data.tabs.length]);

    const handleTabClick = (index: number) => {
        setActiveTab(index);
        stopTabSwitching(); // Eski interval'i durdur
        startTabSwitching(); // Yeni interval başlat
    };

    return (
        <section id="contribution" className="section-regular background-cream">
            <div className="container-large">
                <div className="heading-wrap">
                    <div className="limited-heading-set">
                        <div className="tagline-heading">{data.tagline}</div>
                        <div className="heading-set-3">
                            <h2 className="h3-heading">{data.heading}</h2>
                            <div className="description">{data.description}</div>
                        </div>
                    </div>
                    <div className="action-side">
                        <ShareSocial />
                    </div>
                </div>

                <div className="tabs-component reverted limited w-tabs">
                    <div className="tabs-menu reverted w-tab-menu">
                        {data.tabs.map((tab, index) => (
                            <a
                                key={index}
                                data-w-tab={`Tab ${index + 1}`}
                                className={`tab-link w-inline-block w-tab-link ${index === activeTab ? 'w--current' : ''}`}
                                onClick={() => handleTabClick(index)}
                            >
                                <div className="tab-link-horizontal">
                                    <div className="icon">
                                        <div className={`fa-solid-span ${tab.iconClass}`}>{tab.icon}</div>
                                    </div>
                                    <div className="tab-link-text-wrapper">
                                        <div className="wrap-v-x-small">
                                            <h3 className="h6-heading">{tab.heading}</h3>
                                        </div>
                                        <div className="tab-link-loader">
                                            <div
                                                className="loader-bar"
                                                style={{
                                                    width: index === activeTab ? '100%' : '0%',
                                                    height: '2px',
                                                    transition: index === activeTab ? 'width 5s linear' : 'none',
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                    <div className="tabs-content w-tab-content">
                        {data.tabs.map((tab, index) => (
                            <div key={index} data-w-tab={`Tab ${index + 1}`} className={`tab-pane w-tab-pane ${index === activeTab ? 'w--tab-active' : ''}`} dangerouslySetInnerHTML={{ __html: tab.content }}>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="content-footer">
                    <div className="icon-regular w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.99967 14.6666C4.31777 14.6666 1.33301 11.6818 1.33301 7.99998C1.33301 4.31808 4.31777 1.33331 7.99967 1.33331C11.6815 1.33331 14.6663 4.31808 14.6663 7.99998C14.6663 11.6818 11.6815 14.6666 7.99967 14.6666ZM7.99967 13.3333C10.9452 13.3333 13.333 10.9455 13.333 7.99998C13.333 5.05446 10.9452 2.66665 7.99967 2.66665C5.05415 2.66665 2.66634 5.05446 2.66634 7.99998C2.66634 10.9455 5.05415 13.3333 7.99967 13.3333ZM7.33301 4.66665H8.66634V5.99998H7.33301V4.66665ZM7.33301 7.33331H8.66634V11.3333H7.33301V7.33331Z" fill="#526077"></path>
                        </svg>
                    </div>
                    <div className="paragraph-x-small text-color-gray-600" dangerouslySetInnerHTML={{ __html: data.source }}>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContributionSection;
